const Endpoint = {
  GET_ACL: '/default/access/get-acl',
  HAS_ACCESS_TO_TERM_SELECTION: '/default/access/has-access-to-term-selection',
};

export default Endpoint;
